export enum OsTypeEnum {
  LINUX = 'Linux',
  WINDOWS = 'Windows'
}
